<template>
  <div id="supplier-guide-list">
    <div class="md-layout">
      <div class="md-layout-item md-size-80">
        <h6>Guides</h6>
      </div>
      <div class="md-layout-item md-size-20 text-right">
        <md-button
          v-if="$allowed('supplier.manage')"
          class="md-icon-button md-dense md-primary md-simple"
          @click="showDialog"
        >
          <md-icon>add</md-icon>
          <md-tooltip md-direction="top"
            >Assign a Guide to this Partner</md-tooltip
          >
        </md-button>
      </div>
    </div>

    <template v-if="guides">
      <div class="md=layout">
        <div class="md-layout-item md-size-100">
          <md-table>
            <md-table-row v-for="guide in guides" :key="guide.id">
              <md-table-cell>{{ guide.full_name }}</md-table-cell>
              <md-table-cell class="text-right">
                <md-button
                  v-if="$allowed('supplier.manage')"
                  class="md-just-icon md-simple md-danger "
                  @click="removeGuide(guide.id)"
                >
                  <md-icon>delete</md-icon>
                  <md-tooltip md-direction="top">Remove Guide</md-tooltip>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </div>
      </div>
    </template>

    <md-dialog
      :md-active.sync="showAddUserDialog"
      id="add-guide-dialog"
      class="single-choice-dialog"
    >
      <md-dialog-title>Assign a Guide</md-dialog-title>
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(addGuide)">
          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <md-field>
                <label for="title">Select a Guide</label>
                <md-select v-model="guideId" name="guide" id="guide">
                  <md-option
                    v-for="availableGuide in availableGuides"
                    :value="availableGuide.id"
                    :key="availableGuide.id"
                    >{{ availableGuide.first_name }}
                    {{ availableGuide.last_name }}
                    <span v-if="availableGuide.country"
                      >[{{ availableGuide.country }}]</span
                    >
                  </md-option>
                </md-select>
              </md-field>
            </div>
          </div>

          <md-dialog-actions>
            <md-button
              class="md-primary md-dense"
              @click="showAddUserDialog = false"
              >Cancel</md-button
            >
            <md-button type="submit" class="md-primary md-dense">Add</md-button>
          </md-dialog-actions>
        </form>
      </ValidationObserver>
    </md-dialog>
  </div>
</template>

<script>
import guideApi from "@/services/api/guide";

export default {
  props: ["guides"],
  emits: ["addGuide", "removeGuide"],

  data() {
    return {
      showAddUserDialog: false,
      guideId: null,
      availableGuides: []
      // selectedGuide: null,
    };
  },

  components: {},

  computed: {},

  methods: {
    removeGuide(guideId) {
      this.$emit("removeGuide", guideId);
    },
    addGuide() {
      this.showAddUserDialog = false;
      this.$emit("addGuide", this.guideId);
    },
    showDialog() {
      this.showAddUserDialog = true;
    },
    getAvailableGuides() {
      guideApi
        .getAll()
        .then(response => {
          this.availableGuides = response.data;
        })
        .catch();
    }
  },

  mounted() {
    this.getAvailableGuides();
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";
#add-guide-dialog {
  &::v-deep .md-dialog-container {
    width: 400px;
  }
}

#supplier-guide-list {
  margin-top: 1rem;
  border-top: 2px solid $brand-primary;
  padding-top: 1rem;

  .md-table-cell {
    padding: 4px 4px 4px 0;
    height: 36px;
  }
  .worker-name {
    align-self: center;
  }

  .md-button.md-just-icon,
  .md-icon-button.md-dense {
    width: 21px;
    height: 21px;
    min-width: 21px;
  }

  h6,
  .h6 {
    margin: 0 0 0.5rem 0;
  }
}
</style>
